<template>
  <div id="map-data">
    <div  id="map-data-content">
      <video-data v-show="showVideo" ref="VideoData" @showMapBar="MapInfo"/>
      <baidu-map class="box" @ready="handler" :map-click="false"  v-if="showMap">
        <bml-marker-clusterer :averageCenter="true">
          <div v-for="(marker, i) of markList" :key="i">
            <bm-marker :icon="{url: marker.url, size: { width: 28, height: 28 }}" :position="{lng: marker.changeLng, lat: marker.changeLat}" @click="infoWindowOpen(marker)">
              <bm-info-window :position="{lng: marker.changeLng, lat: marker.changeLat}" style="font-size: 12px;text-align: center; color: #ffffff">

              </bm-info-window>
            </bm-marker>
          </div>
        </bml-marker-clusterer>
      </baidu-map>
    </div>

    <div class="bottom">
      <div class="bottom-topContainer">
        <div class="bottom-topContainer-name">
          <div class="bottom-topContainer-value">设备名称</div>
        </div>
        <div class="bottom-topContainer-name">
          <div class="bottom-topContainer-value">{{deviceName}}</div>
        </div>
        <div class="bottom-topContainer-name">
          <div class="bottom-topContainer-value">设备地址码</div>
        </div>
        <div class="bottom-topContainer-name">
          <div class="bottom-topContainer-value">{{deviceAddr}}</div>
        </div>
      </div>
      <div class="bottom-middleContainer">
        <div class="bottom-middleContainer-name">
          <div class="bottom-middleContainer-value">设备状态</div>
        </div>
        <div class="bottom-middleContainer-name">
          <div class="bottom-middleContainer-value">{{deviceStatus}}</div>
        </div>
        <div class="bottom-middleContainer-name">
          <div class="bottom-middleContainer-value">设备类型</div>
        </div>
        <div class="bottom-middleContainer-name">
          <div class="bottom-middleContainer-value">{{deviceType}}</div>
        </div>
      </div>
      <div class="bottom-footContainer">
        <div class="bottom-footContainer-name">
          <div class="bottom-footContainer-value">设备纬度</div>
        </div>
        <div class="bottom-footContainer-name">
          <div class="bottom-footContainer-value">{{deviceLat}}</div>
        </div>
        <div class="bottom-footContainer-name">
          <div class="bottom-footContainer-value">设备经度</div>
        </div>
        <div class="bottom-footContainer-name">
          <div class="bottom-footContainer-value">{{deviceLng}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 按需引入点聚合
  import {BmlMarkerClusterer} from 'vue-baidu-map'
  // 引入marker
  import BmMarker from 'vue-baidu-map/components/overlays/Marker'
  import VideoData from "./VideoData";
  import {getAttributesServer} from "../../until/api/MeteSoil";
  import moment from 'moment'
  import {pestDeviceState} from "../../until/api/SporePest";
  export default {
    name: 'MapData',
    components: {
      BmlMarkerClusterer,
      BmMarker,
      VideoData
    },
    data() {
      return {
        BMap: '',
        map: '',
        markList:[], //全部点
        showVideo: false,
        showMap: true,
        customerId: '',
        mapDeviceList: [],
        mapSPDevice: [],
        mapXCDevice: [],
        deviceName: '-',
        deviceAddr: '-',
        deviceStatus: '-',
        deviceType: '-',
        deviceLat: '-',
        deviceLng: '-',
      }
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority'))  : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      this.customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')): this.$route.params.customerId;
      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, this.customerId, function (deviceList) {//获取气象墒情设备
        if(deviceList.data.length > 0) {
          for(let i = 0; i < deviceList.data.length; i++) {
            let deviceJson = {};
            deviceJson.id = deviceList.data[i].id.id;
            deviceJson.name = deviceList.data[i].name;
            deviceJson.type = deviceList.data[i].id.entityType;
            that.mapDeviceList.push(deviceJson);
          }
        }
        if(that.mapDeviceList.length > 0) {
          that.setServiceOption(0, that.mapDeviceList.length); //使用递归方法获取每个墒情设备的设备信息
        }
      })
    },

    methods: {
      /**
       * 地图初期化
       * @param BMap
       * @param map
       */
      handler({BMap, map}) {
        map.enableScrollWheelZoom(true);
        map.centerAndZoom(new BMap.Point(107.211388,34.404172), 1);//108.907461,34.254013
        this.BMap = BMap;
        this.map = map;
        map.addControl(new BMap.ScaleControl());
       // map.addControl(new BMap.MapTypeControl({mapTypes: [BMAP_NORMAL_MAP,BMAP_SATELLITE_MAP,BMAP_HYBRID_MAP]}));
        map.setMapType(BMAP_HYBRID_MAP);
        map.addControl(new BMap.MapTypeControl({mapTypes: [BMAP_SATELLITE_MAP,BMAP_HYBRID_MAP,BMAP_NORMAL_MAP,]}));

        const _this = this;
        function Vedio(){
          // 设置默认停靠位置和偏移量
          this.defaultAnchor = BMAP_ANCHOR_TOP_LEFT;
          this.defaultOffset = new BMap.Size(0,0);
        }

        //通过该属性继承BMap控件
        Vedio.prototype=new BMap.Control();

        //必须实现控件的初始化事件，因为当你把控件添加到地图中会首先初始化控件
        Vedio.prototype.initialize=function(map){
          //创建DOM对象
          let div = document.createElement("img");
          div.style.cursor="pointer";
          div.src =  require('../img/video.png');
          div.style.width = "36px";
          div.style.height = "36px";
          div.onclick=function(e){
            _this.showMap = false;
            _this.showVideo = true;
          }
          map.getContainer().appendChild(div);
          return div;
        }
        let vedio = new Vedio();
        map.addControl(vedio);
      },

      /**
       * 获取气象墒情设备的信息
       * @param j
       * @param length
       */
      setServiceOption(j, length) {
        getAttributesServer(this.mapDeviceList[j].type, this.mapDeviceList[j].id).then(response => {
          let option = { "deviceName": this.mapDeviceList[j].name, "deviceAddr": this.mapDeviceList[j].name,
            "lat": 0, "lng": 0, "status": "", "deviceType": "meteSoil", "url": "", "flg": 0}; //设备信息json
          let beforeTime = new Date(moment().subtract(1, "hours")).getTime();//当前时间前一小时时间
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].key == 'latitude') { //判断当前变量是否为纬度
              option.lat = response.data[i].value;
              option.changeLat = response.data[i].value;
            } else if(response.data[i].key == 'longitude') { //判断当前变量是否为经度
              option.lng = response.data[i].value;
              option.changeLng = response.data[i].value;
            } else if(response.data[i].key == 'fx') {
              option.deviceType = "fx";
            } else if(response.data[i].key == 'lastConnectTime') { //判断当前变量是否为最后一次连接时间
              if(response.data[i].value <= beforeTime) { //离线状态
                option.url = require("../img/offLine.png");
                option.status = "offline";
              } else { //在线状态
                option.url = require("../img/onLine.png");
                option.status = 'online'
              }
            }
            if(i ==  response.data.length - 1) { //判断当前为最后一循环
              if(option.lat == 0 && option.lng == 0) { //如果经纬度为0 随机生成经纬度
                option.lat = Math.random() * 30 + 21;
                option.lng = Math.random() * 40 + 85;
                option.changeLat = option.lat;
                option.changeLng = option.lng;
                option.flg = 1;
                this.markList.push(option);
              } else { //如果经纬度不为0
                this.markList.push(option);
              }
            }
          }

          if(++j < length) {
            this.setServiceOption(j, length);//使用递归方法获取每个墒情设备的设备信息
          }
        }).catch(error =>{
          console.log("error", error);
        })
      },

      async getInsectDetail(response) {
        let insectList = response;
        if (insectList != null) {
          for (let i = 0; i < insectList.data.data.length; i++) {
            let option = {
              "deviceName": insectList.data.data[i].devName,
              "deviceAddr": insectList.data.data[i].imei,
              "lat": insectList.data.data[i].lat,
              "lng": insectList.data.data[i].lng,
              "status": insectList.data.data[i].onlineStatus,
              "deviceType": "pest",
              "url": "",
              flg: 0
            };

            option.url = option.status == '在线' ? require("../img/onLine.png") : require("../img/offLine.png");

            if ((option.lat == 0 && option.lng == 0) || (option.lat == undefined && option.lng == undefined)) {
              option.lat = Math.random() * 30 + 21;
              option.lng = Math.random() * 40 + 85;
              option.changeLat = option.lat;
              option.changeLng = option.lng;
              option.flg = 1;
            } else {
              let ggPoint = new BMap.Point(option.lng, option.lat);
              try {
                let point = await this.translatePoint(ggPoint); // 等待 translatePoint 异步执行完成
                option.changeLat = point.lat;
                option.changeLng = point.lng;
              } catch (error) {
                console.error("Coordinate translation failed:", error);
              }
            }

            this.markList.push(option);
          }
        }
      },

      async getSporeDetail(sporeArray) {
        //孢子
        let sporeList = sporeArray;
        if(sporeList != null) {
          for(let i = 0; i < sporeList.length; i++) {
            if(sporeList[i].hasOwnProperty("code") ) {
              let option = {
                "deviceName":  sporeList[i].data[0].deviceName,
                "deviceAddr": sporeList[i].data[0].deviceAddr,
                "lat": sporeList[i].data[0].lat,
                "lng": sporeList[i].data[0].lng,
                "status": sporeList[i].data[0].status,
                "deviceType": "spore",
                "url": "",
                flg: 0
              };

              option.url = option.status == 'online' ?  require("../img/onLine.png") : require("../img/offLine.png");

              if ((option.lat == 0 && option.lng == 0) || (option.lat == undefined && option.lng == undefined)) {
                option.lat = Math.random() * 30 + 21;
                option.lng = Math.random() * 40 + 85;
                option.changeLat = option.lat;
                option.changeLng = option.lng;
                option.flg = 1;
              } else {
                let ggPoint = new BMap.Point(option.lng, option.lat);
                try {
                  let point = await this.translatePoint(ggPoint); // 等待 translatePoint 异步执行完成
                  option.changeLat = point.lat;
                  option.changeLng = point.lng;
                } catch (error) {
                  console.error("Coordinate translation failed:", error);
                }
              }
              this.markList.push(option);
            } else {
              let option = {
                "deviceName":  sporeList[i].deviceName,
                "deviceAddr": sporeList[i].deviceAddr,
                "lat": 0,
                "lng": 0,
                "status":"离线",
                "deviceType": "spore",
                "url": require("../img/offLine.png"),
                flg: 1
              };

              if((option.lat == 0 && option.lng == 0) || (option.lat == undefined && option.lng == undefined)) {
                option.changeLat = Math.random() * 30 + 21;
                option.changeLng = Math.random() * 40 + 85;
              }
              this.markList.push(option);
            }
          }
        }
      },

      translatePoint(point) {
        return new Promise((resolve, reject) => {
          let convertor = new BMap.Convertor();
          convertor.translate([point], 1, 5, (data) => {
            if (data.status === 0) {
              resolve(data.points[0]); // 成功后返回转换后的坐标
            } else {
              console.error('Coordinate conversion failed: ' + data.status);
              resolve(point); // 如果失败，返回原始点
            }
          });
        });
      },

      // /**
      //  * 获取祥辰设备在地图上显示
      //  */
      // getMapXCDevice() {
      //   let that = this;
      //   this.$MeteSoilCommon.getCustomerData(this.customerId, function (response) {
      //     for(let i = 0; i < response.data.length; i++) {
      //       if(response.data[i].key.toString().indexOf('pest') > -1
      //         || response.data[i].key.toString().indexOf('spore') > -1
      //         || response.data[i].key.toString().indexOf('mouse') > -1
      //         || response.data[i].key.toString().indexOf('target') > -1
      //         || response.data[i].key.toString().indexOf('lamp') > -1) {
      //         let dataJson = JSON.parse(response.data[i].value);
      //         let latitude = dataJson.latitude == "" ? 0 : parseFloat(dataJson.latitude);
      //         let longitude = dataJson.longitude == "" ? 0 : parseFloat(dataJson.longitude);
      //         let json = {"deviceType": response.data[i].key, "deviceValue": dataJson.name,  "latitude": latitude, "longitude" : longitude};
      //         that.mapXCDevice.push(json);
      //       }
      //     }
      //
      //     if(that.mapXCDevice.length > 0) {
      //       that.getDeviceStatus(0, that.mapXCDevice.length); //获取每个祥辰设备地图数据
      //     }
      //   })
      // },

      // /**
      //  * 获取每个祥辰设备地图数据
      //  * @param j
      //  * @param length
      //  */
      // getDeviceStatus(j, length) {
      //   if(this.mapXCDevice[j].deviceType == 'pest') {
      //     pestDeviceState(this.mapXCDevice[j].deviceValue).then(response => {
      //       let option = { "deviceName": this.mapXCDevice[j].deviceValue, "deviceAddr": this.mapXCDevice[j].deviceValue,
      //         "lat": this.mapXCDevice[j].latitude, "lng": this.mapXCDevice[j].longitude, "status": "", "deviceType": this.mapXCDevice[j].deviceType, "url": "", "flg": 0}; //设备信息json
      //       if(response.data.data.online == 1) { //当前设备在线
      //         option.status = 'online';
      //         option.url = require("../img/onLine.png");
      //       } else {
      //         option.status = 'offline';
      //         option.url = require("../img/offLine.png");
      //       }
      //       //随机生成经纬度
      //       if(option.lat == 0 && option.lng == 0) {
      //         option.lat = Math.random() * 30 + 21;
      //         option.lng = Math.random() * 40 + 85;
      //         option.flg = 1;
      //       }
      //       this.markList.push(option);
      //       if(++j < length) {
      //         this.getDeviceStatus(j, length); //使用递归获取每个祥辰设备的地图数据
      //       }
      //     })
      //   } else {
      //     let that = this;
      //     this.$SporePestCommon.getDeviceState(this.mapXCDevice[j].deviceValue, function (response) {
      //       let option = { "deviceName": that.mapXCDevice[j].deviceValue, "deviceAddr": that.mapXCDevice[j].deviceValue,
      //         "lat": that.mapXCDevice[j].latitude, "lng": that.mapXCDevice[j].longitude, "status": "", "deviceType": that.mapXCDevice[j].deviceType, "url": "", "flg": 0}; //设备信息json
      //       if(response.status == 1) { //当前设备在线
      //         option.status = 'online';
      //         option.url = require("../img/onLine.png");
      //       } else { //当前设备离线
      //         option.status = 'offline';
      //         option.url = require("../img/offLine.png");
      //       }
      //       //随机生成经纬度
      //       if(option.lat == 0 && option.lng == 0) {
      //         option.lat = Math.random() * 30 + 21;
      //         option.lng = Math.random() * 40 + 85;
      //         option.flg = 1;
      //       }
      //       that.markList.push(option);
      //       if(++j < length) {
      //         that.getDeviceStatus(j, length); //使用递归获取每个祥辰设备的地图数据
      //       }
      //     })
      //   }
      // },

      /**
       * 点击设备小图标获取每个设备详细信息
       * @param marker
       */
      infoWindowOpen (marker) {
        this.deviceName = marker.deviceName; //设备名
        this.deviceAddr = marker.deviceAddr; //设备地址
        if(marker.status == 'online' || marker.status == '在线') {//设备状态
          this.deviceStatus = '在线'
        } else {
          this.deviceStatus = '离线'
        }
        //设备类型
        let deviceType = marker.deviceType;
        switch (true) {
          case deviceType.indexOf('meteSoil') > -1: //气象墒情
            this.deviceType = '气象墒情';
            break;
          case deviceType.indexOf('fx') > -1:
            this.deviceType = '杀虫灯';
            break;
          case deviceType.indexOf('pest') > -1: //虫情
            this.deviceType = '虫情';
            break;
          case deviceType.indexOf('spore') > -1: //孢子
            this.deviceType = '孢子';
            break;
        }
        //this.deviceType = marker.deviceType == 'meteSoil' ? '气象墒情' : (marker.deviceType == 'spore' ? '孢子' : '虫情'); //设备类型

        //纬度经度
        if(marker.flg == 1 ) {
          this.deviceLat = '随机生成';
          this.deviceLng = '随机生成';
        } else {
          this.deviceLat = parseFloat(marker.lat).toFixed(6);
          this.deviceLng = parseFloat(marker.lng).toFixed(6);
        }

      },

      /**
       * 摄像头地图切换
       * @param data
       * @constructor
       */
      MapInfo(data) {
        this.showVideo = false;
        this.showMap = true;
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../less/MapData";
</style>



// WEBPACK FOOTER //
// src/components/view/MapData.vue